import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DateTime } from 'luxon';
import { Agent } from '@models/domains/administration';
import { FinContratFilterParams, AnnuairePosteFilterParams } from '@models/api/requests';

@Injectable({
  providedIn: 'root'
})
export class AgentsService {
  module = environment.webService.server + environment.webService.url + environment.webService.api;
  constructor(private readonly http: HttpClient) {}

  //get agents demandes :
  // les types de listes sont :
  // - all (pour la partie Admin)
  // - recrutement
  // - renouvellement
  getAllAgentsDemandes(typeListe: string): Observable<any> {
    if (typeListe == 'consultation') {
      return this.getAllAgentsPourFiltre();
    }
    return this.http.get<any>(`${this.module}/agents/all?type=${typeListe}`);
  }
  getAllAgents(): Observable<any> {
    return this.http.get<any>(this.module + '/agents/all');
  }
  getAllAgentsPourFiltre(): Observable<any> {
    return this.http.get<any>(this.module + '/agents/all-filtre');
  }
  getAllAgentsDemandesPourFiltre(): Observable<any> {
    return this.http.get<any>(this.module + '/agents/all-filtre-demandes');
  }
  getAgentsDemandes(): Observable<any> {
    return this.http.get<any>(this.module + '/agents');
  }

  // New method to get agent by ID
  getAgentById(id: string): Observable<any> {
    return this.http.get<any>(`${this.module}/agents/${id}`);
  }

  // Add typed filter params for FinContratFilterParams
  private addFinContratFilterParams(params: HttpParams, filters: FinContratFilterParams | null | undefined): HttpParams {
    if (!filters) return params;

    // Add each filter parameter that is not null
    if (filters.agent) params = params.set('id', filters.agent);
    if (filters.fonction) params = params.set('fonction', filters.fonction);
    if (filters.structureHierarchique) params = params.set('libelleStructure', filters.structureHierarchique);

    // Date parameters with start/end time formatting - combined conditions
    if (filters.dateRetourDirection?.isValid) {
      const startDate = filters.dateRetourDirection.set({ hour: 0, minute: 0, second: 0 }).toFormat('yyyy-MM-dd');
      const endDate = filters.dateRetourDirection.set({ hour: 23, minute: 59, second: 59 }).toFormat('yyyy-MM-dd');
      params = params.set('dateRetourDirectionStart', startDate);
      params = params.set('dateRetourDirectionEnd', endDate);
    }

    if (filters.dateDebutContrat?.isValid) {
      const startDate = filters.dateDebutContrat.set({ hour: 0, minute: 0, second: 0 }).toFormat('yyyy-MM-dd');
      const endDate = filters.dateDebutContrat.set({ hour: 23, minute: 59, second: 59 }).toFormat('yyyy-MM-dd');
      params = params.set('dateDebutContratStart', startDate);
      params = params.set('dateDebutContratEnd', endDate);
    }

    if (filters.dateFinContrat?.isValid) {
      const startDate = filters.dateFinContrat.set({ hour: 0, minute: 0, second: 0 }).toFormat('yyyy-MM-dd');
      const endDate = filters.dateFinContrat.set({ hour: 23, minute: 59, second: 59 }).toFormat('yyyy-MM-dd');
      params = params.set('dateFinContratStart', startDate);
      params = params.set('dateFinContratEnd', endDate);
    }

    if (filters.dateEntreeOrganisation?.isValid) {
      const startDate = filters.dateEntreeOrganisation.set({ hour: 0, minute: 0, second: 0 }).toFormat('yyyy-MM-dd');
      const endDate = filters.dateEntreeOrganisation.set({ hour: 23, minute: 59, second: 59 }).toFormat('yyyy-MM-dd');
      params = params.set('dateEntreeStart', startDate);
      params = params.set('dateEntreeEnd', endDate);
    }

    if (filters.dateExpirationCarteSejour?.isValid) {
      const startDate = filters.dateExpirationCarteSejour.set({ hour: 0, minute: 0, second: 0 }).toFormat('yyyy-MM-dd');
      const endDate = filters.dateExpirationCarteSejour.set({ hour: 23, minute: 59, second: 59 }).toFormat('yyyy-MM-dd');
      params = params.set('dateExpirationCSStart', startDate);
      params = params.set('dateExpirationCSEnd', endDate);
    }

    if (filters.infoService) params = params.set('serviceFonctionnelLibelle', filters.infoService);
    if (filters.posteBudgete !== null) params = params.set('budgete', filters.posteBudgete.toString());
    if (filters.typeCT) params = params.set('typeContrat', filters.typeCT.toString());
    if (filters.codeEngagement) params = params.set('codeEngagement', filters.codeEngagement);
    if (filters.infoPoste) params = params.set('info_poste', filters.infoPoste);
    if (filters.agentRemplace) params = params.set('agentRemplaceNom', filters.agentRemplace);
    if (filters.categoriePoste) params = params.set('categoriePoste', filters.categoriePoste.toString());
    if (filters.grade) params = params.set('grade', filters.grade);
    if (filters.tauxSitAdmin) params = params.set('tauxEmploi', filters.tauxSitAdmin);
    if (filters.statut !== null) {
      params = params.set('flagDemandeEnCours', filters.statut.toString());
    }

    return params;
  }

  getAllAgentWithParams(offset: number, limit: number, filters?: FinContratFilterParams | null) {
    let params = new HttpParams().set('page', offset.toString()).set('size', limit.toString());
    params = this.addFinContratFilterParams(params, filters);
    return this.http.get<any>(`${this.module}/agents/fin-contrat`, { params });
  }

  getAgentDelegationWithParams(offset: number, limit: number, filtre: string | null = null) {
    let params = new HttpParams().set('page', offset.toString()).set('size', limit.toString());
    if (filtre && filtre.trim() !== '') {
      console.log('Valeur de filtre :', filtre);

      console.log('Params envoyés :', params.toString());

      params = params.set('filterGenerique', filtre.trim());
    }
    const url = `${this.module}/agents`;
    return this.http.get<any>(url, { params });
  }

  ModifierAgent(data: any, id: number) {
    return this.http.put<any>(this.module + '/agents/' + id, data);
  }

  getDestinataireResponsable(
    typeDemande: string,
    serviceId: string | number | null | undefined,
    directionId?: string | number | null
  ): Observable<any> {
    let params = new HttpParams().set('typeListe', 'responsable');
    if (directionId != null) {
      params = params.set('idDirection', directionId.toString());
    }
    if (serviceId != null) {
      params = params.set('idService', serviceId.toString());
    }
    return this.http.get<any>(`${this.module}/agents/agents-validators/${typeDemande}`, { params });
  }

  getDestinataireDirecteur(typeDemande: string, directionId?: string | null): Observable<any> {
    let params = new HttpParams().set('typeListe', 'directeur');
    if (directionId) {
      params = params.set('idDirection', directionId);
    }
    return this.http.get<any>(`${this.module}/agents/agents-validators/${typeDemande}`, { params });
  }

  getChargedGPEEC(typeDemande: string, directionId?: string | null, serviceId?: string | null): Observable<any> {
    let params = new HttpParams().set('typeListe', 'gpeec');
    if (directionId) {
      params = params.set('idDirection', directionId);
    }
    if (serviceId) {
      params = params.set('idService', serviceId);
    }
    return this.http.get<any>(`${this.module}/agents/agents-validators/${typeDemande}`, { params });
  }

  getLibelleChargeGPEEC(typeDemande: string, idDirection: string | undefined): Observable<any> {
    return this.http.get<any>(`${this.module}/agents/agents-validators/libelle/${typeDemande}?typeListe=gpeec&idDirection=${idDirection}`);
  }

  getDestinataireDRH(typeDemande: string): Observable<any> {
    return this.http.get<any>(`${this.module}/agents/agents-validators/${typeDemande}?typeListe=drh`);
  }

  getDestinataireDG(typeDemande: string, directionId?: string | null): Observable<any> {
    let params = new HttpParams().set('typeListe', 'dg');
    if (directionId) {
      params = params.set('idDirection', directionId);
    }
    return this.http.get<any>(`${this.module}/agents/agents-validators/${typeDemande}`, { params });
  }

  getDestinataireDGS(typeDemande: string): Observable<any> {
    return this.http.get<any>(`${this.module}/agents/agents-validators/${typeDemande}?typeListe=dgs`);
  }

  getDestinataireArchivageRh(
    typeDemande: string,
    directionId?: string | number | null,
    serviceId?: string | number | null
  ): Observable<any> {
    let params = new HttpParams().set('typeListe', 'archivage_rh');
    if (directionId != null) {
      params = params.set('idDirection', directionId.toString());
    }
    if (serviceId != null) {
      params = params.set('idService', serviceId.toString());
    }
    return this.http.get<any>(`${this.module}/agents/agents-validators/${typeDemande}`, { params });
  }

  getCurrentAgent(): Observable<Agent> {
    return this.http.get<Agent>(`${this.module}/agents/moi`);
  }
  getDelegueAgents(agentId: any): Observable<any> {
    let url = agentId != '' && agentId != null ? '?type=delegues&idAgent=' + agentId : '?type=mes delegues';
    return this.http.get<any>(this.module + '/agents/all' + url);
  }
}
